import React from 'react';
import { ButtonComp } from 'atoms/Buttons';
import ImageComponent from 'atoms/Image/Container/ImageComponent';
import HamburgerMenuIcon from 'styles/staticAssets/images/MenuIcon.svg';
import HeaderLogo from 'styles/staticAssets/images/kfcLogo.svg';
import { MenuLinksComp } from './SharedTemplates/MenuLinksComp';
import { LanguageSelectorComp } from 'organisms/LanguageSelector/LanguageSelectorComp';
import { HeaderSigninComp } from './SharedTemplates/HeaderSigninComp';
import { CartIconComp } from './SharedTemplates/CartIcon';
import { getTernaryValue, getCheckIfAnyOnePass, redirectToHomePage } from 'common/utilities/utils';
import STYLE_SCRIPT_CONST from 'common/style-scripts/constants';
import useStyleScripts from 'common/custom-hooks/useStyleScripts';

export const HeaderComponentItems = props => {
  const { navRight, headerLinks, kfcLogo, history, onNavigateHandler, openHamburger } = props;
  const CustomStyledDiv = useStyleScripts(STYLE_SCRIPT_CONST?.HEADER_STYLES);

  return (
    CustomStyledDiv && (
      <div>
        <CustomStyledDiv
          className={`root-header-view ${getTernaryValue(
            getCheckIfAnyOnePass(
              history?.location?.pathname?.includes('privacy-policy'),
              history?.location?.pathname?.includes('terms-conditions'),
              history?.location?.pathname?.includes('protected-disclosure'),
            ),
            'root-header-view-policies',
            '',
          )}`}
        >
          <ButtonComp
            data-testid='hamburger-button'
            className='header-item-buttons header-hamburger-icon'
            onClick={openHamburger}
          >
            <ImageComponent srcFile={HamburgerMenuIcon} alt='hamburger-icon' />
          </ButtonComp>
          <div
            data-testid='kfc-logo'
            className={`header-logo-mobile ${getTernaryValue(
              history?.location?.pathname?.includes('cart'),
              'header-logo-mobile-cart',
              '',
            )}`}
            onClick={() => redirectToHomePage({ history })}
          >
            <ImageComponent srcFile={kfcLogo?.src || HeaderLogo} alt='KFC LOGO' />
          </div>
          <MenuLinksComp headerLinks={headerLinks} onNavigateHandler={onNavigateHandler} />
          <div className='right-nav-container'>
            {<LanguageSelectorComp defaultTooltipShow={true} />}
            <HeaderSigninComp navRight={navRight} />
            <CartIconComp gotoCart={onNavigateHandler} navRight={navRight} />
          </div>
        </CustomStyledDiv>
        <div className='border'> </div>
      </div>
    )
  );
};
